export const BRAND_NAME = 'Sky11';
// Note: It is the main site url. Ex - sky11.com, etc.
export const BRAND_DOMAIN = 'sky11.website';
export const PROVIDER_ID = 'BetFair';
